<div class="video-contatiner">
	<canvas #canvasDetect></canvas>
	<canvas #canvas></canvas>
</div>
<div *ngIf="pictureData" class="image-contatiner">
	<img [src]="pictureData" />
</div>
<div class="top-layer">
	<mat-toolbar>
		<mat-toolbar-row>
			<button mat-icon-button (click)="rotate()" [disabled]="pictureData">
        <mat-icon>rotate_left</mat-icon>
      </button>
			<button *ngIf="canSwapCamera" mat-icon-button (click)="swapCamera()" [disabled]="pictureData">
        <mat-icon>camera_rear</mat-icon>
      </button>
			<button *ngIf="canTorch" mat-icon-button (click)="toggleTorch()">
        <mat-icon *ngIf="!torchOn">flash_on</mat-icon>
        <mat-icon *ngIf="torchOn">flash_off</mat-icon>
      </button>
			<span class="flex-fill"></span>
			<button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
		</mat-toolbar-row>
	</mat-toolbar>
	<mat-slider *ngIf="canZoom" vertical [value]="zoomValue" [max]="zoomMax" [min]="zoomMin" [step]="zoomStep" (change)="onZoomChange($event)" [disabled]="pictureData"></mat-slider>
	<div class="flex-fill"></div>
	<div class="take-picture-container" style="height: 6rem">
		<button *ngIf="!pictureData && enableCapture" mat-icon-button  (click)="takePicture()" style="transform: scale(2);">
      <mat-icon>lens</mat-icon>
    </button>
		<button *ngIf="!pictureData && !enableCapture" mat-icon-button disabled style="transform: scale(2);">
      <mat-icon  class="material-icons-two-tone">lens</mat-icon>
    </button>
	</div>
	<mat-toolbar *ngIf="pictureData" class="take-picture-container" style="height: 5rem;">
		<mat-toolbar-row>
			<button mat-button (click)="retake()">{{'REPETIR'|translate}}</button>
			<span class="flex-fill"></span>
			<button mat-button (click)="use()">{{'CONFIRMAR'|translate}}</button>
		</mat-toolbar-row>
	</mat-toolbar>
</div>
